import { apiService } from "@/_services";

const state = {
  all: {}
};

const actions = {
  getAll({ commit }, params) {
    commit("getAllRequest");
    apiService.getAll(params).then(
      currencies_intraday_history =>
        commit("getAllSuccess", currencies_intraday_history),
      error => commit("getAllFailure", error)
    );
  },
  logout({ commit }) {
    commit("logout");
  }
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, currencies_intraday_history) {
    state.all = { items: currencies_intraday_history };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  }
};

export const currencies_intraday_history = {
  namespaced: true,
  state,
  actions,
  mutations
};
